import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { getNodeScrollOffset } from 'utils/dom-helpers';
import { LinkBlock } from 'bricks';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function ModalPopupStateless({ children, isActive, isFixed, onClose, containerRef }) {
  const handleClose = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.target === e.currentTarget) {
      onClose();
    }
    return false;
  };
  return (
    <div className={cx('container', { active: isActive, fixed: isFixed })} ref={containerRef}>
      <LinkBlock className={cx('screen')} onClick={handleClose} />
      <div className={cx('component')}>{children}</div>
    </div>
  );
}

ModalPopupStateless.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  isFixed: PropTypes.bool,
  onClose: PropTypes.func,
  containerRef: PropTypes.any,
};

/**
 * ModalAuthContainer watches resize/scroll to always position popup under header
 * or at the top of the screen when scrolled down
 */
export default class ModalPopup extends React.Component {
  constructor() {
    super();
    this.state = { isFixed: false };
    this.containerRef = React.createRef();
  }

  componentDidMount() {
    this.updatePosition();
    document.addEventListener('resize', this.updatePosition);
    document.addEventListener('scroll', this.updatePosition);
  }

  componentDidUpdate() {
    this.updatePosition();
  }

  componentWillUnmount() {
    document.removeEventListener('resize', this.updatePosition);
    document.removeEventListener('scroll', this.updatePosition);
  }

  updatePosition = () => {
    const { isFixed } = this.state;
    const containerNode = this.containerRef.current;

    if (document.body.scrollTop >= -getNodeScrollOffset(containerNode)) {
      return isFixed !== true && this.setState({ isFixed: true });
    }
    return isFixed !== false && this.setState({ isFixed: false });
  };

  render() {
    const { isFixed } = this.state;
    return (
      <ModalPopupStateless {...this.props} isFixed={isFixed} containerRef={this.containerRef} />
    );
  }
}

ModalPopup.propTypes = {
  children: PropTypes.node,
  isActive: PropTypes.bool,
  onClose: PropTypes.func,
};
